<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-news heroicon heroicon-sm"
  >
    <path
      class="heroicon-news-paper heroicon-component-fill"
      fill="#FFFFFF"
      d="M0 49V6l.59.59L2 8l.59-.59.82-.82L4 6l.59.59.82.82L6 8l.59-.59.82-.82L8 6l.59.59.82.82L10 8l.59-.59.82-.82L12 6l.59.59.82.82L14 8l.59-.59.82-.82L16 6l.59.59.82.82L18 8l.59-.59.82-.82L20 6l.59.59.82.82L22 8l.59-.59.82-.82L24 6l.59.59.82.82L26 8l.59-.59.82-.82L28 6l.59.59.82.82L30 8l.59-.59.82-.82L32 6l.59.59.82.82L34 8l.59-.59.82-.82L36 6l.59.59.82.82L38 8l.59-.59.82-.82L40 6l.59.59.82.82L42 8l.59-.59.82-.82L44 6l.59.59.82.82L46 8l.59-.59.82-.82L48 6l.59.59.82.82L50 8l1.41-1.41L52 6v2l.59.59.82.82.59.59 1.41-1.41L56 8v4l.59.59.82.82.59.59 1.41-1.41L60 12v37a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
    ></path>
    <polygon
      class="heroicon-news-top-image heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="7 19 7 26 45 26 45 19"
    ></polygon>
    <polygon
      class="heroicon-news-bottom-image heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="7 33 24 33 24 47 7 47"
    ></polygon>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M51 8l8 8v33a4 4 0 1 1-8 0V8z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M0 49V6l.59.59L2 8l.59-.59.82-.82L4 6l.59.59.82.82L6 8l.59-.59.82-.82L8 6l.59.59.82.82L10 8l.59-.59.82-.82L12 6l.59.59.82.82L14 8l.59-.59.82-.82L16 6l.59.59.82.82L18 8l.59-.59.82-.82L20 6l.59.59.82.82L22 8l.59-.59.82-.82L24 6l.59.59.82.82L26 8l.59-.59.82-.82L28 6l.59.59.82.82L30 8l.59-.59.82-.82L32 6l.59.59.82.82L34 8l.59-.59.82-.82L36 6l.59.59.82.82L38 8l.59-.59.82-.82L40 6l.59.59.82.82L42 8l.59-.59.82-.82L44 6l.59.59.82.82L46 8l.59-.59.82-.82L48 6l.59.59.82.82L50 8l1.41-1.41L52 6v2l.59.59.82.82.59.59 1.41-1.41L56 8v4l.59.59.82.82.59.59 1.41-1.41L60 12v37a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5zm55 3a3 3 0 0 0 3-3V16.83l-1.41-1.42-.59-.58V48a2 2 0 0 1-2 2h-1.83A3 3 0 0 0 55 52zm-3-4h2V12.83l-1.41-1.42-.59-.58V48zM2 49a3 3 0 0 0 3 3h46c-.63-.84-1-1.87-1-3V10.83L48.59 9.4 48 8.83l-.59.58L46 10.83 44.59 9.4 44 8.83l-.59.58L42 10.83 40.59 9.4 40 8.83l-.59.58L38 10.83 36.59 9.4 36 8.83l-.59.58L34 10.83 32.59 9.4 32 8.83l-.59.58L30 10.83 28.59 9.4 28 8.83l-.59.58L26 10.83 24.59 9.4 24 8.83l-.59.58L22 10.83 20.59 9.4 20 8.83l-.59.58L18 10.83 16.59 9.4 16 8.83l-.59.58L14 10.83 12.59 9.4 12 8.83l-.59.58L10 10.83 8.59 9.4 8 8.83l-.59.58L6 10.83 4.59 9.4 4 8.83l-.59.58L2 10.83V49zm4-34h40v1H6v-1zm0 14h40v1H6v-1zm1-11h39v9H6v-9h1zm0 1v7h38v-7H7zM6 32h19v16H6V32zm1 1v14h17V33H7zm20-1h19v1H27v-1zm0 3h9v1h-9v-1zm10 0h9v1h-9v-1zm-10 2h9v1h-9v-1zm10 0h9v1h-9v-1zm-10 2h9v1h-9v-1zm10 0h9v1h-9v-1zm-10 2h9v1h-9v-1zm10 0h9v1h-9v-1zm-10 2h9v1h-9v-1zm10 0h9v1h-9v-1zm-10 2h9v1h-9v-1zm10 0h9v1h-9v-1zm-10 2h9v1h-9v-1zm10 0h9v1h-9v-1z"
    ></path>
  </svg>
</template>
